module.exports = __webpack_public_path__ + "img/ad.5d196e60.svg";